import { render, staticRenderFns } from "./SharedVideo.vue?vue&type=template&id=68bf6606&scoped=true"
import script from "./SharedVideo.vue?vue&type=script&lang=js"
export * from "./SharedVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf6606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68bf6606')) {
      api.createRecord('68bf6606', component.options)
    } else {
      api.reload('68bf6606', component.options)
    }
    module.hot.accept("./SharedVideo.vue?vue&type=template&id=68bf6606&scoped=true", function () {
      api.rerender('68bf6606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SharedVideo/SharedVideo.vue"
export default component.exports